import { createTheme, alpha } from "@mui/material/styles";
import typography from "../theme/typography";
import shadows, { customShadows } from "../theme/shadows";
import shape from "../theme/shape";
import ComponentsOverride from "../theme/overrides";

export const useDomainTheme = (domainConfig) => {
  const { palette } = domainConfig;

  // Existing: set favicon from domain config
  const publicUrl = process.env.PUBLIC_URL || '';
  let faviconLink = document.getElementById("favicon");
  if (faviconLink) {
    faviconLink.href = `${publicUrl}/${domainConfig.faviconUrl}`;
  } else {
    faviconLink = document.createElement("link");
    faviconLink.id = "favicon";
    faviconLink.rel = "icon";
    faviconLink.href = `${publicUrl}/${domainConfig.faviconUrl}`;
    document.head.appendChild(faviconLink);
  }
  // Existing: inject CSS variable for --app-color
  const dynamicVariables = `
  :root {
    --app-color: ${palette.primary.main};
  }
  `;
  const styleElement = document.createElement("style");
  styleElement.appendChild(document.createTextNode(dynamicVariables));
  document.head.appendChild(styleElement);

  // Updated: pass full theme config (palette + typography + shadows + shape)
  const updatedCustomShadows = {
    ...customShadows,
    primary: `0 8px 16px 0 ${alpha(palette.primary.main, 0.24)}`,
  };

  const domainTheme = createTheme({
    palette,
    shape,
    typography,
    shadows,
    customShadows: updatedCustomShadows,
  });

  // Apply component overrides
  domainTheme.components = ComponentsOverride(domainTheme);

  return domainTheme;
};
